import { render, staticRenderFns } from "./Frozen.vue?vue&type=template&id=415c5b74&"
import script from "./Frozen.vue?vue&type=script&lang=js&"
export * from "./Frozen.vue?vue&type=script&lang=js&"
import style0 from "./Frozen.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports